import { LinkButton, Loading } from "@evertrue/et-components";
import { useIdentity } from "base/identity-resolver";
import { bulkAddConstituentsToJourney } from "apps/journeys/utils/api-requests/modal-actions";
import Proptypes from "prop-types";
import { useTasksNotificationContext } from "apps/tasks/hooks/tasks-notification-context.js";
import EverTrue from "app";
import ErrorLogger from "entities/helpers/error-log-helper";
import SelectedContactsSource from "apps/contact/sources/selected-contacts-source";
import { trackJourneysAction } from "apps/journeys/utils/helpers.js";

const JourneySelectorController = ({
  contactIds = [],
  closePopover,
  journeys = [],
  loading = false,
  allSelected,
  totalResultsCount,
}) => {
  const { getAndSetGlobalTasksDueCount } = useTasksNotificationContext();
  const {
    org: { id: oid },
    user: { id: userId },
  } = useIdentity();

  const handleJourneyClick = async (label, value) => {
    // TO DO: Convert to a bulk add endpoint
    const promises = contactIds.map(
      async (contactId) => await bulkAddConstituentsToJourney(contactId, userId, oid, value)
    );
    try {
      trackJourneysAction("list-portfolio");
      await Promise.all(promises);
      EverTrue.Alert.success(`Successfully moved constituents into ${label} cadence.`);
    } catch (e) {
      ErrorLogger.error("Error adding constituents", { extra: { error: e, page_name: "JourneySelector" } });
    }
    getAndSetGlobalTasksDueCount();
    SelectedContactsSource.clearAllSelectedState();
    closePopover();
  };

  if (totalResultsCount > 50 && allSelected) {
    return (
      <div className="trip-selector--empty">
        Unable to add more than 50 Constitents to a Cadence at one time. Please undo your selection.
      </div>
    );
  }

  return (
    <div style={{ padding: "8px" }}>
      <p style={{ padding: "4px 16px", margin: 0 }}>
        <strong>Your Cadences</strong>
      </p>
      <ul>
        {loading ? (
          <div style={{ position: "relative", height: "150px" }}>
            <Loading />
          </div>
        ) : journeys.length > 0 ? (
          journeys.map(({ label, value }) => (
            <li key={value} style={{ padding: "4px 30px", lineHeight: "23px" }}>
              <LinkButton title={label} onClick={() => handleJourneyClick(label, value)}>
                {label}
              </LinkButton>
            </li>
          ))
        ) : (
          <div className="trip-selector--empty">No Cadences available</div>
        )}
      </ul>
    </div>
  );
};

JourneySelectorController.propTypes = {
  contactIds: Proptypes.array.isRequired,
  closePopover: Proptypes.func.isRequired,
  journeys: Proptypes.array,
  loading: Proptypes.bool,
  allSelected: Proptypes.bool,
  totalResultsCount: Proptypes.number,
};

export default JourneySelectorController;
